import { camelize } from '@ember/string'
import RouteTemplate from 'ember-route-template'
import { DrivingTestsHistory } from 'teacher-ui-client/components/giraffe/charts/driving-tests/history'
import { DrivingTestsTotals } from 'teacher-ui-client/components/giraffe/charts/driving-tests/totals'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { t } from 'ember-intl'
import type { DrivingTestsReRoute } from 'teacher-ui-client/reporting/ui-scope/re/driving-tests/route'
import { not, or } from 'ember-truth-helpers'
import { array } from '@ember/helper'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import { concat } from '@ember/helper'
import type { TOC } from '@ember/component/template-only'

interface Signature {
  model: ModelFor<DrivingTestsReRoute>
}

export const ReDrivingTests: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.drivingTests"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if (or @model.drivingTestsTotals @model.drivingTestsHistory) true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not (or @model.drivingTestsTotals @model.drivingTestsHistory)}}>
    <div
      class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
    >
      {{#if @model.drivingTestsTotals}}
        <DrivingTestsTotals
          @data={{@model.drivingTestsTotals}}
          @product={{@model.product}}
          @summaryTitle={{t (concat "reporting.summaryTitles.drivingTestsTotals." (camelize @model.uiScope.scope))}}
          @title={{t "reporting.chartTitles.drivingTestsTotals"}}
          @tooltip={{t "reporting.tooltips.drivingTestsTotals.re"}}
        />
      {{/if}}
    </div>
    <div class="my-10">
      {{#if @model.drivingTestsHistory}}
        <DrivingTestsHistory
          @students={{@model.scopedStudents}}
          @subco={{(isSubco)}}
          @drivingTestsHistoryData={{@model.drivingTestsHistory}}
          @studentRouteName="reporting.ui-scope.re.student-summary"
          @product={{@model.product}}
          @uiScope={{@model.uiScope.scope}}
          @tooltip={{t
            "reporting.tooltips.drivingTestsHistory.re"
            htmlSafe=true
            sightWordsCount=15
            lettersSoundsCount=15
            contentWordsCount=15
          }}
        />
      {{/if}}
    </div>
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReDrivingTests)
